import { matchDataByStatus } from '../../utils/matchDataByStatus';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
const MatchStatusIcon = props => {
  const {
    matchStatus
  } = props;
  if (!matchStatus) {
    return null;
  }
  const matchData = matchDataByStatus[matchStatus];
  return matchData && /*#__PURE__*/_jsx(IconHolder, {
    icon: matchData.IconComponent,
    color: matchData.iconColor,
    size: matchData.size
  });
};
export default MatchStatusIcon;